import React from 'react';

import ButtonsRow from 'components/ButtonsRow';

export interface CalendarFooterProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the <CalendarFooter />, consider using <Button />. `CalendarFooter` content will be wrapped by `ButtonsRow`, passing content is mandatory. */
  children: React.ReactNode;
  /** To customize the wrapper style. */
  style?: React.CSSProperties
}

/**
 * `CalendarFooter` content will be wrapped by `ButtonsRow`.
 * All props will be provided to the root DOM element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
*/
const CalendarFooter = React.forwardRef<HTMLElement, CalendarFooterProps>((props: CalendarFooterProps, ref) => {
  const {
    style,
    ...otherProps
  } = props;
  return <ButtonsRow style={{ width: '100%', ...style }} ref={ref} {...otherProps} />;
});

CalendarFooter.defaultProps = {
  style: {}
};

CalendarFooter.displayName = 'CalendarFooter';

export default CalendarFooter;
